module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_Ukranian.a7e8acfd.png";